const getRecursiveOutput = (lastOutput, rows) =>
  lastOutput
    ? rows.reduce((acc, row) => {
        if (row[lastOutput.id]) {
          return acc + row[lastOutput.id];
        }
        return acc;
      }, 0)
    : 0;

export default getRecursiveOutput;
